export default __webpack_public_path__ + "static/media/heroku-redis.f00bbfbd.svg";